import { type ChangeRequest, getLastChangeRequestStatus } from 'models';
import { useEffect, useState } from 'react';
import { Card, Col, Row, Text } from 'ui';
import { useGetRemainingTime } from './hooks';

type P = {
  changeRequests?: ChangeRequest[];
  startTime: Date;
};

const EventDetailCountdown = ({ changeRequests, startTime }: P) => {
  const getRemainingTime = useGetRemainingTime();
  const [remainingTime, setRemainingTime] = useState(getRemainingTime({ targetDate: startTime }));
  const status = getLastChangeRequestStatus(changeRequests);

  useEffect(() => {
    const interval = setInterval(() => {
      const newRemainingTime = getRemainingTime({ targetDate: startTime });
      setRemainingTime(newRemainingTime);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime, startTime]);

  if (remainingTime.length === 0 || status === 'denied') {
    return null;
  }

  return (
    <Card className="event-detail-countdown">
      <Text>Event starts in</Text>
      <Row gutter="ms" justify="center">
        {remainingTime.map(({ label, value }) => (
          <Col className="event-detail-countdown__column" key={label}>
            <Text className="event-detail-countdown__text--extra-large" type="title" weight="medium">
              {value}
            </Text>
            <Text size="small">{label}</Text>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default EventDetailCountdown;
